import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamBillingDTO } from "@shaarp/common";

export const CardBillingTrial = ({ billing }: { billing: TeamBillingDTO }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("components.cardBillingTrial.title")}</CardTitle>
        <CardDescription></CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-4">
          <div className="col-span-1">
            <div className="text-sm text-gray-500">
              {t("components.cardBillingTrial.until")}
            </div>
            <div className="text-lg font-semibold">
              {new Date(billing.trialEndsAt || "").toLocaleDateString()}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
